module.exports = __webpack_public_path__ + "static/img/icon_header_logo.e5a50d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_header_logo.png
// module id = ROYs
// module chunks = 1